import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import type {
	NotificationPreferencesResponse,
	UpdateNotificationPreferencesBody,
} from "@zplanem/responses"
import { apiFetch } from "../../lib/api-client"
import { queryKeys } from "../../lib/query-keys"

const PATH = "/api/common/users/me/notification-preferences"

export function useNotificationPreferences(userId: string | undefined) {
	const queryClient = useQueryClient()
	const query = useQuery({
		queryKey: queryKeys.notificationPreferences(),
		queryFn: () =>
			apiFetch<NotificationPreferencesResponse>(PATH, { method: "GET" }),
		enabled: !!userId,
		select: (res) => res.preferences,
	})

	const mutation = useMutation({
		mutationFn: (body: UpdateNotificationPreferencesBody) =>
			apiFetch<NotificationPreferencesResponse>(PATH, {
				method: "PATCH",
				body: JSON.stringify(body),
			}),
		onSuccess: (res) => {
			queryClient.setQueryData(queryKeys.notificationPreferences(), res)
		},
	})

	return {
		preferences: query.data,
		isLoading: query.isLoading,
		error: query.error,
		save: mutation.mutateAsync,
		isSaving: mutation.isPending,
		saveError: mutation.error,
	}
}
